export default __webpack_public_path__ + "static/media/breaking-bad.7b8efead.gif";